import { apiGetFutureOrders, apiSetFutureOrders } from "Root/api/apiProfile";
import toastService from "Root/profile/toastService";
import { setFutureOrders } from "../../actionCreators/makeActionCreator";
import { LoadNextOrderDatesThunk } from "./nextOrderDates";
export const LoadFutureOrdersThunk = () => async (dispatch) => {
    try {
        const data = await apiGetFutureOrders();
        dispatch(setFutureOrders(data));
    }
    catch (error) {
        toastService.errorMessage("Something went wrong. Try later.");
    }
};
export const UpdateFutureOrdersThunk = (body, index, toggleLoading) => async (dispatch) => {
    try {
        dispatch(setFutureOrders(body));
        const data = await apiSetFutureOrders(body);
        if (index === 0) {
            dispatch(LoadNextOrderDatesThunk());
        }
    }
    catch (error) {
        toastService.errorMessage("Something went wrong. Try later.");
        const data = await apiGetFutureOrders();
        dispatch(setFutureOrders(data));
    }
    finally {
        toggleLoading();
    }
};
